<template>
  <div>
    <div class="limitBox">
      <div class="logo">
        <img :src="getSetting.logo" />
      </div>
      <div class="company-name">
        {{ language === "en" ? getSetting.enTitle : language === "ru" ? getSetting.rusTitle : getSetting.title }}
      </div>
      <div class="elfrom">
        <el-form :model="form" ref="form" label-position="right" :rules="rules">
          <el-form-item :label="$hs('账号:', 'Account:', 'Compte:')">
            <el-input v-model="form.userAccount" size="small"></el-input>
          </el-form-item>
          <el-form-item :label="$t('password') + ':'">
            <el-input type="password" v-model="form.userPassword" size="small"></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" class="btn" @click="submit">{{ $t("login") }}</el-button>
      </div>
      <div class="login-content">
        {{
          $hs(
            "请登录账号，若暂无账号，请联系我们开通!",
            "Please log in with your account. If you don't have an account yet, please contact us to have one set up!",
            "Veuillez vous connecter avec votre compte. Si vous n'en avez pas encore, veuillez nous contacter pour l'activer!",
          )
        }}
      </div>
      <div class="contact-content">Phon/Whatapp/Wechat: {{ getSetting.whatsApp }}</div>
      <img :src="getSetting.weChat" alt="" class="image" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { LoginMemberNoCode } from "@/api/login";

export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        userAccount: "",
        userPassword: "",
        valideCode: "",
      },
      rules: {
        userAccount: [
          {
            required: true,
            message: this.$t("inputUserAccount"),
            trigger: "blur",
          },
        ],
        userPassword: [
          {
            required: true,
            message: this.$t("inputPassword"),
            trigger: "blur",
          },
          { min: 6, message: this.$t("passwordLength"), trigger: "blur" },
        ],
        valideCode: [
          {
            required: true,
            message: this.$t("inputVaildeCode"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  async created() {},
  computed: {
    ...mapGetters("setting", {
      getSetting: "get_setting",
    }),
    ...mapState("operate", ["language"]),
  },
  methods: {
    ...mapActions("operate", {
      setisPassPages: "set_isPassPages",
    }),
    ...mapActions("user", ["set_userInfo"]),
    handleClose(done) {
      done();
    },
    openModel() {
      this.dialogVisible = true;
    },
    submit() {
      let _this = this;
      this.$refs.form.validate((values) => {
        if (!values) return false;
        if (!_this.form.userAccount) {
          _this.$message.error(_this.$t("inputUserAccount"));
          return;
        }
        if (!_this.form.userPassword) {
          _this.$message.error(_this.$t("inputPassword"));
          return;
        }
        LoginMemberNoCode({ ...this.form })
          .then((res) => {
            if (res.success) {
              sessionStorage.setItem("isPass", "true");
              _this.set_userInfo(res.data);
              _this.setisPassPages(false);
              _this.$message.success(_this.$t("loginSuccess"));
              _this.$router.replace("/home");
            }
          })
          .catch((err) => {
            if (err.includes("D1632") || err.includes("D1631")) {
              _this.$message.error(_this.$t("CodeError"));
            } else if (err.includes("D1629")) {
              _this.$message.error(_this.$t("notreviewed"));
            } else if (err.includes("D1628")) {
              _this.form.userPassword = "";
              _this.$message.error(_this.$t("loginError"));
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  display: none;
}

.elfrom {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-left: -50px;

  :deep(.el-form) {
    .el-form-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0px;
      width: 100%;
    }

    .el-form-item__label {
      width: 120px !important;
    }
  }

  .btn {
    margin-left: 15px;
    height: 70px;
    min-width: 70px;
  }
}

.limitBox {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .logo {
    padding: 20px 0;
    cursor: pointer;

    & img {
      width: auto;
      height: 100px;
    }
  }

  .company-name {
    font-size: 28px;
    font-weight: bold;
    color: #3191d8;
  }

  .login-content {
    font-size: 24px;
    margin-top: 20px;
    color: black;
    font-weight: bold;
  }

  .contact-content {
    font-size: 20px;
    margin-top: 10px;
    color: rgb(66, 66, 66);
    font-weight: bold;
  }

  .image {
    width: auto;
    height: 250px;
    margin-top: 10px;
  }
}
</style>
